import PsikotestParticipantRoute from "./PsikotestParticipantRoute";

function PsikotestParticipantLayout() {
  return <PsikotestParticipantRoute />;
}

export default PsikotestParticipantLayout;
